import { CloudinaryAdvancedImage } from '../Misc/CloudinaryImage'
import React from 'react'
import styled from '@emotion/styled'
import { FullWidth } from '../Misc/FullWidth'

export const InfographicBlockPublic = ({
  asset,
  backgroundColor,
  cloudName,
}: {
  asset: {
    id: number
    assetDetails: any
  }
  cloudName?: string
  backgroundColor?: string
}): JSX.Element | null => {
  if (asset.assetDetails.cloudinaryFileId) {
    return (
      <FullWidth backgroundColor={backgroundColor}>
        <ImageWrapper>
          <CloudinaryAdvancedImage
            cloudName={cloudName}
            imagePublicId={asset.assetDetails.cloudinaryFileId}
            style={{
              objectFit: 'scale-down',
              backgroundRepeat: 'no-repeat',
              maxWidth: '885px',
              height: '100%',
              display: 'block',
            }}
            imageAltText='Progress Report Infographic'
          />
        </ImageWrapper>
      </FullWidth>
    )
  }

  if (!asset.assetDetails.src) {
    return <span />
  }

  return (
    <FullWidth backgroundColor={backgroundColor}>
      <ImageWrapper>
        <InfographicContainer
          src={asset.assetDetails.src}
          alt='Progress Report Infographic'
        />
      </ImageWrapper>
    </FullWidth>
  )
}

const ImageWrapper = styled('div')`
  height: 500px;
  display: flex;
  justify-content: center;
`

const InfographicContainer = styled('img')`
  display: block;
  max-width: 885px;
  max-height: 500px;
  margin: 0 auto 48px;
`
